export const TARGET_IDENTIFIERS = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  // We transform 'p' into 'body1' to follow mui's syntax but
  // for the underlying data this is actually 'p'.
  PARAGRAPH: 'body1',
  CARD: 'bentobox--card',
  HEADER_NAVIGATION: 'bentobox--header-navigation',
  HEADER_NAVIGATION_ACTIVE: 'bentobox--header-navigation:active',
  HEADER_NAVIGATION_HOVER: 'bentobox--header-navigation:hover',
  MENU_ITEM_DESCRIPTION: 'bentobox--menu-item-description',
  MENU_ITEM_NAME: 'bentobox--menu-item-name',
  MENU_NAVIGATION: 'bentobox--menu-navigation',
  MENU_NAVIGATION_ACTIVE: 'bentobox--menu-navigation:active',
  MENU_NAVIGATION_HOVER: 'bentobox--menu-navigation:hover',
  MENU_SECTION_TITLE: 'bentobox--menu-section-title',
  PAGE: 'bentobox--page',
  PAGE_ERROR: 'bentobox--page--error',
  PRIMARY_BUTTON: 'bentobox--primary-button',
  PRIMARY_BUTTON_HOVER: 'bentobox--primary-button:hover'
};

export const TYPOGRAPHY_STYLE_ATTRIBUTES = [
  'color',
  'fontFamily',
  'fontWeight',
  'fontSize',
  'fontStyle',
  'letterSpacing',
  'lineHeight',
  'textTransform'
];
